var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$currentUser.role == "account"
    ? _c("div", { staticClass: "main-content bg-white" }, [
        _c("span", { staticClass: "alert-danger" }, [
          _vm._v("У вас нет доступа к этой странице.")
        ])
      ])
    : _vm.$currentUser.role != "account"
    ? _c("div", { staticClass: "main-content bg-white" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.isMobile
          ? _c("div", [
              _c(
                "div",
                { staticClass: "col-lg-12" },
                [
                  _c("b", [_vm._v("Сохранённые шаблоны")]),
                  _vm._v(" "),
                  _vm.templates.length == 0
                    ? _c("div", [_vm._v("У вас нет сохранённых шаблонов.")])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-list-group",
                    _vm._l(_vm.templates, function(template) {
                      return _vm.templates.length > 0
                        ? _c(
                            "div",
                            [
                              _c("b-list-group-item", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex w-100 justify-content-between"
                                  },
                                  [
                                    _c("div", [
                                      _c("span", [
                                        _vm._v(_vm._s(template.title))
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          " (" +
                                            _vm._s(
                                              _vm._f("formatDate")(
                                                template.date_from
                                              )
                                            ) +
                                            " - " +
                                            _vm._s(
                                              _vm._f("formatDate")(
                                                template.date_to
                                              )
                                            ) +
                                            ")"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-button-group",
                                      { staticStyle: { height: "30px" } },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn btn-outline-success btn-sm",
                                            attrs: {
                                              href: _vm.getExcelParamsStringMobile(
                                                "xlsx",
                                                template.params_string
                                              )
                                            }
                                          },
                                          [_vm._v("Excel")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn btn-outline-success btn-sm",
                                            attrs: {
                                              href: _vm.getExcelParamsStringMobile(
                                                "csv",
                                                template.params_string
                                              )
                                            }
                                          },
                                          [_vm._v("CSV")]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    }),
                    0
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isMobile
          ? _c("div", { staticClass: "row mb-2" }, [
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
                [
                  _vm.isXl
                    ? _c(
                        "b-button-group",
                        {
                          key: _vm.dateRange,
                          staticClass: "datePickerXl filterComponent"
                        },
                        [
                          _c("date-range-picker", {
                            ref: "picker",
                            attrs: {
                              "locale-data": _vm.dateRangeLocalFormat,
                              opens: "right",
                              ranges: _vm.dateRanges
                            },
                            on: {
                              update: function($event) {
                                return _vm.selectRange($event)
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "input",
                                  fn: function(picker) {
                                    return [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm._f("formatDateRange")(
                                              _vm.range.startDate
                                            )
                                          ) +
                                          " - " +
                                          _vm._s(
                                            _vm._f("formatDateRange")(
                                              _vm.range.endDate
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3800565667
                            ),
                            model: {
                              value: _vm.range,
                              callback: function($$v) {
                                _vm.range = $$v
                              },
                              expression: "range"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            { attrs: { size: "sm", variant: "primary" } },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-calendar-check-o"
                              })
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isXl
                    ? _c(
                        "b-input-group",
                        { key: _vm.dateRange, staticClass: "filterComponent" },
                        [
                          _c("div"),
                          _vm._v(" "),
                          _c(
                            "b-input-group-append",
                            [
                              _c("datepicker", {
                                staticClass: "date dateLeft",
                                attrs: {
                                  "input-class": "form-control dateFrom",
                                  "monday-first": "",
                                  size: "sm",
                                  language: _vm.ru,
                                  placeholder: "С:"
                                },
                                model: {
                                  value: _vm.range.startDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.range, "startDate", $$v)
                                  },
                                  expression: "range.startDate"
                                }
                              }),
                              _vm._v(" "),
                              _c("datepicker", {
                                staticClass: "date dateRight",
                                attrs: {
                                  "input-class": "form-control dateTo",
                                  size: "sm",
                                  "monday-first": "",
                                  language: _vm.ru,
                                  placeholder: "По:"
                                },
                                model: {
                                  value: _vm.range.endDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.range, "endDate", $$v)
                                  },
                                  expression: "range.endDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2" },
                [
                  _c(
                    "b-btn",
                    {
                      staticClass: "mb-2 mainButton",
                      class: _vm.showCollapse1 ? "collapsed" : null,
                      attrs: {
                        size: "sm",
                        text: "Search",
                        variant: "outline-success",
                        "aria-expanded": _vm.showCollapse1 ? "true" : "false",
                        "aria-controls": "collapse-1"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onClick(1)
                        }
                      }
                    },
                    [
                      _vm._v("\n                Колонки\n                "),
                      _vm.showCollapse1
                        ? _c("span", [
                            _c("i", { staticClass: "icon-fa icon-fa-minus" })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showCollapse1
                        ? _c("span", [
                            _c("i", { staticClass: "icon-fa icon-fa-plus" })
                          ])
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mb-2 mainButton",
                      class: _vm.showCollapse2 ? "collapsed" : null,
                      attrs: {
                        variant: "outline-success",
                        size: "sm",
                        "aria-expanded": _vm.showCollapse2 ? "true" : "false",
                        "aria-controls": "collapse-3"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onClick(2)
                        }
                      }
                    },
                    [
                      _vm._v("\n                Фильтры\n                "),
                      _vm.showCollapse2
                        ? _c("span", [
                            _c("i", { staticClass: "icon-fa icon-fa-minus" })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showCollapse2
                        ? _c("span", [
                            _c("i", { staticClass: "icon-fa icon-fa-plus" })
                          ])
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mb-2 mainButton",
                      class: _vm.showCollapse3 ? "collapsed" : null,
                      attrs: {
                        variant: "outline-success",
                        size: "sm",
                        "aria-expanded": _vm.showCollapse3 ? "true" : "false",
                        "aria-controls": "collapse-3"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onClick(3)
                        }
                      }
                    },
                    [
                      _vm._v("\n                Шаблоны\n                "),
                      _vm.showCollapse3
                        ? _c("span", [
                            _c("i", { staticClass: "icon-fa icon-fa-minus" })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showCollapse3
                        ? _c("span", [
                            _c("i", { staticClass: "icon-fa icon-fa-plus" })
                          ])
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2" },
                [
                  _c(
                    "b-btn",
                    {
                      staticClass: "mainButton mb-2",
                      attrs: { size: "sm", text: "Search", variant: "success" },
                      on: {
                        click: function($event) {
                          return _vm.confirmSettings()
                        }
                      }
                    },
                    [_vm._v("\n                Сформировать\n            ")]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isMobile
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-lg-12" },
                [
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2",
                      attrs: { id: "collapse-1" },
                      model: {
                        value: _vm.showCollapse1,
                        callback: function($$v) {
                          _vm.showCollapse1 = $$v
                        },
                        expression: "showCollapse1"
                      }
                    },
                    [
                      _c("b-card", [
                        _c("div", { staticClass: "row mb-3" }, [
                          _c("div", { staticClass: "col-lg-12" }, [
                            _c(
                              "h3",
                              { staticStyle: { color: "#6c757d !important" } },
                              [_vm._v("Выберите данные:")]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.date.value,
                                    callback: function($$v) {
                                      _vm.$set(_vm.columns.date, "value", $$v)
                                    },
                                    expression: "columns.date.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.date.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.date_month.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.date_month,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.date_month.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.date_month.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.user.value,
                                    callback: function($$v) {
                                      _vm.$set(_vm.columns.user, "value", $$v)
                                    },
                                    expression: "columns.user.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.user.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.sales_managers.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.sales_managers,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.sales_managers.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.columns.sales_managers.label)
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value:
                                      _vm.columns.account_manager_name.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.account_manager_name,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "columns.account_manager_name.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.columns.account_manager_name.label
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.partner_id.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.partner_id,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.partner_id.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.partner_id.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.offer_title.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.offer_title,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.offer_title.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.columns.offer_title.label)
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.type.value,
                                    callback: function($$v) {
                                      _vm.$set(_vm.columns.type, "value", $$v)
                                    },
                                    expression: "columns.type.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.type.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.affise_platform.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.affise_platform,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.affise_platform.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.columns.affise_platform.label)
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.affise_id.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.affise_id,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.affise_id.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.affise_id.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.offer_id.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.offer_id,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.offer_id.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.offer_id.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.advertiser.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.advertiser,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.advertiser.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.advertiser.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.sub1.value,
                                    callback: function($$v) {
                                      _vm.$set(_vm.columns.sub1, "value", $$v)
                                    },
                                    expression: "columns.sub1.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.sub1.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.sub2.value,
                                    callback: function($$v) {
                                      _vm.$set(_vm.columns.sub2, "value", $$v)
                                    },
                                    expression: "columns.sub2.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.sub2.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.sub3.value,
                                    callback: function($$v) {
                                      _vm.$set(_vm.columns.sub3, "value", $$v)
                                    },
                                    expression: "columns.sub3.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.sub3.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.sub4.value,
                                    callback: function($$v) {
                                      _vm.$set(_vm.columns.sub4, "value", $$v)
                                    },
                                    expression: "columns.sub4.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.sub4.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.platforms.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.platforms,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.platforms.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.platforms.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.tracker.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.tracker,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.tracker.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.tracker.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.channel.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.channel,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.channel.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.channel.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.source_title.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.source_title,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.source_title.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.columns.source_title.label)
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.source_group.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.source_group,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.source_group.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.columns.source_group.label)
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          this.$currentUser.department === "adkey"
                            ? _c(
                                "div",
                                { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      attrs: { name: "check-button" },
                                      model: {
                                        value:
                                          _vm.columns.application_owner.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.columns.application_owner,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "columns.application_owner.value"
                                      }
                                    },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.columns.application_owner.label
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.responsibleBuyer.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.responsibleBuyer,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.responsibleBuyer.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.columns.responsibleBuyer.label)
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.is_test.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.is_test,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.is_test.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.is_test.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-4 mb-3" }, [
                          _c("div", { staticClass: "col-lg-12" }, [
                            _c(
                              "h3",
                              { staticStyle: { color: "#6c757d !important" } },
                              [_vm._v("Выберите расчёты:")]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.expense_currency.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.expense_currency,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.expense_currency.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.expense.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.expense_usd.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.expense_usd,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.expense_usd.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.columns.expense_usd.label)
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.avg_expense_rate.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.avg_expense_rate,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.avg_expense_rate.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.columns.avg_expense_rate.label)
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value:
                                      _vm.columns.expense_with_discount_usd
                                        .value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.expense_with_discount_usd,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "columns.expense_with_discount_usd.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.columns.expense_with_discount_usd
                                          .label
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.discount_usd.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.discount_usd,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.discount_usd.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.columns.discount_usd.label)
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.leads_count.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.leads_count,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.leads_count.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.columns.leads_count.label)
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.lead_rate_usd.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.lead_rate_usd,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.lead_rate_usd.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.columns.lead_rate_usd.label)
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.lead_rate.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.lead_rate,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.lead_rate.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.lead_rate.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.lead_currency.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.lead_currency,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.lead_currency.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.revenue.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.avg_revenue_rate.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.avg_revenue_rate,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.avg_revenue_rate.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.columns.avg_revenue_rate.label)
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.revenue_usd.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.revenue_usd,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "columns.revenue_usd.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.columns.revenue_usd.label)
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.profit.value,
                                    callback: function($$v) {
                                      _vm.$set(_vm.columns.profit, "value", $$v)
                                    },
                                    expression: "columns.profit.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.profit.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.roi.value,
                                    callback: function($$v) {
                                      _vm.$set(_vm.columns.roi, "value", $$v)
                                    },
                                    expression: "columns.roi.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.roi.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.gm_rev.value,
                                    callback: function($$v) {
                                      _vm.$set(_vm.columns.gm_rev, "value", $$v)
                                    },
                                    expression: "columns.gm_rev.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.gm_rev.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value:
                                      _vm.columns.revenue_conversions.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.revenue_conversions,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "columns.revenue_conversions.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.columns.revenue_conversions.label
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value:
                                      _vm.columns.revenue_conversions_usd.value,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.columns.revenue_conversions_usd,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "columns.revenue_conversions_usd.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.columns.revenue_conversions_usd
                                          .label
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-2 col-md-3 col-sm-3" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button" },
                                  model: {
                                    value: _vm.columns.gm.value,
                                    callback: function($$v) {
                                      _vm.$set(_vm.columns.gm, "value", $$v)
                                    },
                                    expression: "columns.gm.value"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.columns.gm.label))
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2",
                      attrs: { id: "collapse-2" },
                      model: {
                        value: _vm.showCollapse2,
                        callback: function($$v) {
                          _vm.showCollapse2 = $$v
                        },
                        expression: "showCollapse2"
                      }
                    },
                    [
                      _c("b-card", [
                        _c("div", { staticClass: "row mb-2" }, [
                          _vm.$currentUser.role == "admin" ||
                          _vm.$currentUser.role == "leader"
                            ? _c(
                                "div",
                                {
                                  staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2"
                                },
                                [
                                  _c(
                                    "v-select",
                                    {
                                      attrs: {
                                        label: "name",
                                        options: _vm.users,
                                        required: "",
                                        placeholder: "Медиабайер",
                                        multiple: ""
                                      },
                                      model: {
                                        value: _vm.user,
                                        callback: function($$v) {
                                          _vm.user = $$v
                                        },
                                        expression: "user"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "no-options" },
                                          slot: "no-options"
                                        },
                                        [_vm._v("Совпадений не найдено.")]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    options: _vm.selectOffers,
                                    filter: _vm.filterOffers,
                                    required: "",
                                    label: "title",
                                    placeholder: "Оффер",
                                    multiple: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "option",
                                        fn: function(option) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(option.id) +
                                                  ") " +
                                                  _vm._s(option.title)
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1477995661
                                  ),
                                  model: {
                                    value: _vm.search,
                                    callback: function($$v) {
                                      _vm.search = $$v
                                    },
                                    expression: "search"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "no-options" },
                                      slot: "no-options"
                                    },
                                    [_vm._v("Совпадений не найдено.")]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    options: _vm.sources,
                                    filter: _vm.filterSources,
                                    required: "",
                                    label: "title",
                                    placeholder: "Источник",
                                    multiple: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "option",
                                        fn: function(option) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(option.id) +
                                                  ") " +
                                                  _vm._s(option.title)
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1477995661
                                  ),
                                  model: {
                                    value: _vm.source,
                                    callback: function($$v) {
                                      _vm.source = $$v
                                    },
                                    expression: "source"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "no-options" },
                                      slot: "no-options"
                                    },
                                    [_vm._v("Совпадений не найдено.")]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    options: _vm.groups,
                                    required: "",
                                    placeholder: "Группа",
                                    multiple: ""
                                  },
                                  model: {
                                    value: _vm.group,
                                    callback: function($$v) {
                                      _vm.group = $$v
                                    },
                                    expression: "group"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "no-options" },
                                      slot: "no-options"
                                    },
                                    [_vm._v("Совпадений не найдено.")]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    options: _vm.trackers,
                                    multiple: "",
                                    placeholder: "Трекер"
                                  },
                                  model: {
                                    value: _vm.selectedTracker,
                                    callback: function($$v) {
                                      _vm.selectedTracker = $$v
                                    },
                                    expression: "selectedTracker"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "no-options" },
                                      slot: "no-options"
                                    },
                                    [_vm._v("Совпадений не найдено.")]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c(
                                "v-select",
                                {
                                  staticClass: "insertInput",
                                  attrs: {
                                    options: _vm.currency,
                                    placeholder: "Валюта расхода"
                                  },
                                  model: {
                                    value: _vm.selectedExpenseCurrency,
                                    callback: function($$v) {
                                      _vm.selectedExpenseCurrency = $$v
                                    },
                                    expression: "selectedExpenseCurrency"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "no-options" },
                                      slot: "no-options"
                                    },
                                    [_vm._v("Совпадений не найдено.")]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c(
                                "v-select",
                                {
                                  staticClass: "insertInput",
                                  attrs: {
                                    options: _vm.currency,
                                    placeholder: "Валюта дохода"
                                  },
                                  model: {
                                    value: _vm.selectedRevenueCurrency,
                                    callback: function($$v) {
                                      _vm.selectedRevenueCurrency = $$v
                                    },
                                    expression: "selectedRevenueCurrency"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "no-options" },
                                      slot: "no-options"
                                    },
                                    [_vm._v("Совпадений не найдено.")]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    options: _vm.affisePlatforms,
                                    placeholder: "Аффайз платформа"
                                  },
                                  model: {
                                    value: _vm.selectedAffisePlatform,
                                    callback: function($$v) {
                                      _vm.selectedAffisePlatform = $$v
                                    },
                                    expression: "selectedAffisePlatform"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "no-options" },
                                      slot: "no-options"
                                    },
                                    [_vm._v("Совпадений не найдено.")]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    options: _vm.platforms,
                                    placeholder: "Платформа",
                                    required: "",
                                    multiple: ""
                                  },
                                  model: {
                                    value: _vm.selectedPlatforms,
                                    callback: function($$v) {
                                      _vm.selectedPlatforms = $$v
                                    },
                                    expression: "selectedPlatforms"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "no-options" },
                                      slot: "no-options"
                                    },
                                    [_vm._v("Совпадений не найдено.")]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c("v-select", {
                                attrs: {
                                  options: _vm.isTestOptions,
                                  searchable: false,
                                  clearable: false,
                                  placeholder: "Тест"
                                },
                                model: {
                                  value: _vm.isTest,
                                  callback: function($$v) {
                                    _vm.isTest = $$v
                                  },
                                  expression: "isTest"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          this.$currentUser.department === "adkey"
                            ? _c(
                                "div",
                                {
                                  staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2"
                                },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      options: _vm.applicationOwnerOptions,
                                      placeholder: "Приложение",
                                      clearable: false,
                                      searchable: false
                                    },
                                    model: {
                                      value: _vm.application_owner,
                                      callback: function($$v) {
                                        _vm.application_owner = $$v
                                      },
                                      expression: "application_owner"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c("v-select", {
                                attrs: {
                                  options: _vm.types,
                                  placeholder: "Тип",
                                  clearable: false,
                                  searchable: false,
                                  multiple: ""
                                },
                                model: {
                                  value: _vm.type,
                                  callback: function($$v) {
                                    _vm.type = $$v
                                  },
                                  expression: "type"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c("b-form-input", {
                                staticClass: "insertInput",
                                staticStyle: { height: "35px" },
                                attrs: { type: "text", placeholder: "Subid-1" },
                                model: {
                                  value: _vm.selectedSub1,
                                  callback: function($$v) {
                                    _vm.selectedSub1 = $$v
                                  },
                                  expression: "selectedSub1"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c("b-form-input", {
                                staticClass: "insertInput",
                                staticStyle: { height: "35px" },
                                attrs: { type: "text", placeholder: "Subid-2" },
                                model: {
                                  value: _vm.selectedSub2,
                                  callback: function($$v) {
                                    _vm.selectedSub2 = $$v
                                  },
                                  expression: "selectedSub2"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c("b-form-input", {
                                staticClass: "insertInput",
                                staticStyle: { height: "35px" },
                                attrs: { type: "text", placeholder: "Subid-3" },
                                model: {
                                  value: _vm.selectedSub3,
                                  callback: function($$v) {
                                    _vm.selectedSub3 = $$v
                                  },
                                  expression: "selectedSub3"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c("v-select", {
                                staticStyle: { height: "35px" },
                                attrs: {
                                  options: _vm.sub4Options,
                                  placeholder: "Subid-4",
                                  label: "text",
                                  clearable: false,
                                  searchable: false
                                },
                                model: {
                                  value: _vm.selectedSub4,
                                  callback: function($$v) {
                                    _vm.selectedSub4 = $$v
                                  },
                                  expression: "selectedSub4"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c("b-form-input", {
                                staticClass: "insertInput",
                                staticStyle: { height: "35px" },
                                attrs: {
                                  type: "text",
                                  placeholder: "ID партнёра"
                                },
                                model: {
                                  value: _vm.selectedPartnerId,
                                  callback: function($$v) {
                                    _vm.selectedPartnerId = $$v
                                  },
                                  expression: "selectedPartnerId"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    placeholder: "Сейл",
                                    label: "name",
                                    options: _vm.salesManagers,
                                    reduce: function(manager) {
                                      return manager.id
                                    },
                                    multiple: ""
                                  },
                                  model: {
                                    value: _vm.selectedSalesManagers,
                                    callback: function($$v) {
                                      _vm.selectedSalesManagers = $$v
                                    },
                                    expression: "selectedSalesManagers"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "no-options" },
                                      slot: "no-options"
                                    },
                                    [_vm._v("Совпадений не найдено.")]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    placeholder: "Аккаунт",
                                    label: "name",
                                    options: _vm.accountManagers,
                                    reduce: function(accountManager) {
                                      return accountManager.id
                                    },
                                    multiple: ""
                                  },
                                  model: {
                                    value: _vm.selectedAccountManagers,
                                    callback: function($$v) {
                                      _vm.selectedAccountManagers = $$v
                                    },
                                    expression: "selectedAccountManagers"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "no-options" },
                                      slot: "no-options"
                                    },
                                    [_vm._v("Совпадений не найдено.")]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    options: _vm.advertisers,
                                    placeholder: "Рекламодатель",
                                    reduce: function(advertiser) {
                                      return advertiser.value
                                    },
                                    multiple: ""
                                  },
                                  model: {
                                    value: _vm.selectedAdvertiser,
                                    callback: function($$v) {
                                      _vm.selectedAdvertiser = $$v
                                    },
                                    expression: "selectedAdvertiser"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "no-options" },
                                      slot: "no-options"
                                    },
                                    [_vm._v("Совпадений не найдено.")]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c("v-select", {
                                attrs: {
                                  options: _vm.channels,
                                  placeholder: "Канал продаж",
                                  clearable: false,
                                  searchable: false,
                                  reduce: function(channel) {
                                    return channel.value
                                  },
                                  multiple: ""
                                },
                                model: {
                                  value: _vm.channel,
                                  callback: function($$v) {
                                    _vm.channel = $$v
                                  },
                                  expression: "channel"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                            [
                              _c("v-select", {
                                attrs: {
                                  options: _vm.userGroups,
                                  label: "title",
                                  placeholder: "Группа пользователей",
                                  clearable: false,
                                  searchable: false,
                                  reduce: function(userGroup) {
                                    return userGroup.id
                                  },
                                  multiple: ""
                                },
                                model: {
                                  value: _vm.selectedUserGroups,
                                  callback: function($$v) {
                                    _vm.selectedUserGroups = $$v
                                  },
                                  expression: "selectedUserGroups"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2",
                      attrs: { id: "collapse-3" },
                      model: {
                        value: _vm.showCollapse3,
                        callback: function($$v) {
                          _vm.showCollapse3 = $$v
                        },
                        expression: "showCollapse3"
                      }
                    },
                    [
                      _c("b-card", [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-lg-4" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-lg-12 mb-2" }, [
                                _c("b", [_vm._v("Сохранить шаблон отчёта")])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-lg-12 mb-2" }, [
                                _c("div", [
                                  _vm._v("Введите уникальное название отчёта:")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-lg-12 mb-2" },
                                [
                                  _c("b-form-input", {
                                    staticClass: "col-sm-10",
                                    attrs: {
                                      placeholder: "Название:",
                                      size: "sm"
                                    },
                                    model: {
                                      value: _vm.newTemplateTitle,
                                      callback: function($$v) {
                                        _vm.newTemplateTitle = $$v
                                      },
                                      expression: "newTemplateTitle"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.submitted && !_vm.newTemplateTitle
                                    ? _c(
                                        "span",
                                        { staticClass: "alert-danger" },
                                        [_vm._v("Введите название шаблона.")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-lg-12 mb-2" }, [
                                _c("div", [
                                  _vm._v(
                                    "Период отчёта: " +
                                      _vm._s(
                                        _vm._f("formatDate")(
                                          _vm.range.startDate
                                        )
                                      ) +
                                      " - " +
                                      _vm._s(
                                        _vm._f("formatDate")(_vm.range.endDate)
                                      ) +
                                      "\n                                    "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-lg-12" },
                                [
                                  _c(
                                    "b-btn",
                                    {
                                      staticClass: "mr-2 mb-2",
                                      attrs: { size: "sm", variant: "success" },
                                      on: {
                                        click: function($event) {
                                          return _vm.saveTemplate()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        Сохранить\n                                    "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-8" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-lg-12 mb-2" }, [
                                _c("b", [_vm._v("Сохранённые шаблоны")])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-lg-12" },
                                [
                                  _vm.templates.length == 0
                                    ? _c("div", [
                                        _vm._v(
                                          "У вас нет сохранённых шаблонов."
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(_vm.templates, function(template) {
                                    return _vm.templates.length > 0
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            { staticClass: "mb-3" },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(template.title) +
                                                  " (" +
                                                  _vm._s(
                                                    _vm._f("formatDate")(
                                                      template.date_from
                                                    )
                                                  ) +
                                                  " -\n                                            " +
                                                  _vm._s(
                                                    _vm._f("formatDate")(
                                                      template.date_to
                                                    )
                                                  ) +
                                                  ")\n                                            "
                                              ),
                                              _c(
                                                "b-btn",
                                                {
                                                  staticClass: "ml-3 mr-3",
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "outline-warning"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.getTemplate(
                                                        template.params_string
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                Применить\n                                                "
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-fa icon-fa-spinner"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-btn",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "outline-danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.deleteTemplate(
                                                        template.id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                Удалить\n                                                "
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-fa icon-fa-trash-o"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ])
                                      : _vm._e()
                                  })
                                ],
                                2
                              )
                            ])
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isMobile
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-8 col-md-9 col-lg-10 col-xl-10 mb-2" },
                [
                  _c("h4", [
                    _vm._v(
                      "Период: " +
                        _vm._s(_vm._f("formatDate")(_vm.range.startDate)) +
                        " - " +
                        _vm._s(_vm._f("formatDate")(_vm.range.endDate))
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2" },
                [
                  _c("b-button-group", { staticClass: "mb-2 float-right" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-outline-success btn-sm",
                        attrs: { href: _vm.getExcelParamsString("xlsx") }
                      },
                      [_vm._v("Excel")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-outline-success btn-sm",
                        attrs: { href: _vm.getExcelParamsString("csv") }
                      },
                      [_vm._v("CSV")]
                    )
                  ])
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isMobile
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                !_vm.reports
                  ? _c("div", { staticClass: "text-danger" }, [
                      _vm._v("Выберите колонки.")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.reports
                  ? _c(
                      "div",
                      [
                        _c(
                          "b-table",
                          {
                            attrs: {
                              hover: "",
                              responsive: "",
                              bordered: "",
                              small: "",
                              items: _vm.reports,
                              fields: _vm.customFields,
                              "no-local-sorting": "",
                              "sort-by": _vm.sortBy,
                              busy: _vm.isBusy,
                              "sort-desc": _vm.sortDesc,
                              "sort-direction": _vm.sortDirection
                            },
                            on: {
                              "update:sortBy": function($event) {
                                _vm.sortBy = $event
                              },
                              "update:sort-by": function($event) {
                                _vm.sortBy = $event
                              },
                              "sort-changed": function($event) {
                                return _vm.getReports(
                                  1,
                                  $event,
                                  _vm.user,
                                  _vm.search
                                )
                              },
                              "update:sortDesc": function($event) {
                                _vm.sortDesc = $event
                              },
                              "update:sort-desc": function($event) {
                                _vm.sortDesc = $event
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "cell(date)",
                                  fn: function(row) {
                                    return [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatDate")(row.item.date)
                                          )
                                        )
                                      ])
                                    ]
                                  }
                                },
                                {
                                  key: "cell(type)",
                                  fn: function(row) {
                                    return [
                                      row.item.type
                                        ? _c("div", [
                                            _vm._v(
                                              "\n                           " +
                                                _vm._s(
                                                  _vm.getOfferTypeByValue(
                                                    row.item.type
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  }
                                },
                                {
                                  key: "cell(application_owner)",
                                  fn: function(row) {
                                    return [
                                      row.item.application_owner
                                        ? _c("div", [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.getAppOwnerByValue(
                                                    row.item.application_owner
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  }
                                },
                                {
                                  key: "cell(date_month)",
                                  fn: function(row) {
                                    return [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatMonth")(
                                              row.item.date_month
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  }
                                },
                                {
                                  key: "cell(user)",
                                  fn: function(row) {
                                    return [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(row.item.user) +
                                            " " +
                                            _vm._s(row.item.network_partner_id)
                                        )
                                      ])
                                    ]
                                  }
                                },
                                {
                                  key: "cell(roi)",
                                  fn: function(row) {
                                    return [
                                      row.item.roi !== null
                                        ? _c("div", [
                                            _vm._v(_vm._s(row.item.roi))
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      row.item.roi === null
                                        ? _c("div", [_vm._v("0.00")])
                                        : _vm._e()
                                    ]
                                  }
                                },
                                {
                                  key: "cell(gm_rev)",
                                  fn: function(row) {
                                    return [
                                      row.item.gm_rev !== null
                                        ? _c("div", [
                                            _vm._v(_vm._s(row.item.gm_rev))
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      row.item.gm_rev === null
                                        ? _c("div", [_vm._v("0.00")])
                                        : _vm._e()
                                    ]
                                  }
                                },
                                {
                                  key: "cell(avg_expense_rate)",
                                  fn: function(row) {
                                    return [
                                      row.item.avg_expense_rate !== null
                                        ? _c("div", [
                                            _vm._v(
                                              _vm._s(row.item.avg_expense_rate)
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      row.item.avg_expense_rate === null
                                        ? _c("div", [_vm._v("0.00")])
                                        : _vm._e()
                                    ]
                                  }
                                },
                                {
                                  key: "cell(avg_revenue_rate)",
                                  fn: function(row) {
                                    return [
                                      row.item.avg_revenue_rate !== null
                                        ? _c("div", [
                                            _vm._v(
                                              _vm._s(row.item.avg_revenue_rate)
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      row.item.avg_revenue_rate === null
                                        ? _c("div", [_vm._v("0.00")])
                                        : _vm._e()
                                    ]
                                  }
                                },
                                {
                                  key: "cell(platforms)",
                                  fn: function(row) {
                                    return [
                                      !row.item.offer
                                        ? _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("shield")(
                                                  row.item.platforms
                                                )
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      row.item.offer
                                        ? _c(
                                            "div",
                                            _vm._l(
                                              row.item.offer.platforms,
                                              function(item) {
                                                return _c("div", [
                                                  _c("span", [
                                                    _vm._v(_vm._s(item) + " ")
                                                  ])
                                                ])
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                },
                                {
                                  key: "cell(is_test)",
                                  fn: function(row) {
                                    return [
                                      row.item.is_test == 0
                                        ? _c("div", [_vm._v("Нет")])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      row.item.is_test == 1
                                        ? _c("div", [_vm._v("Да")])
                                        : _vm._e()
                                    ]
                                  }
                                },
                                {
                                  key: "cell(revenue_conversions)",
                                  fn: function(row) {
                                    return [
                                      row.item.revenue_conversions !== null
                                        ? _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                row.item.revenue_conversions
                                              ) +
                                                " " +
                                                _vm._s(
                                                  row.item.conversions_currency
                                                )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      row.item.revenue_conversions === null
                                        ? _c("div", [_vm._v("0.00")])
                                        : _vm._e()
                                    ]
                                  }
                                },
                                {
                                  key: "cell(revenue_conversions_usd)",
                                  fn: function(row) {
                                    return [
                                      row.item.revenue_conversions_usd !== null
                                        ? _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                row.item.revenue_conversions_usd
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      row.item.revenue_conversions_usd === null
                                        ? _c("div", [_vm._v("0.00")])
                                        : _vm._e()
                                    ]
                                  }
                                },
                                {
                                  key: "cell(gm)",
                                  fn: function(row) {
                                    return [
                                      row.item.gm !== null
                                        ? _c("div", [
                                            _vm._v(_vm._s(row.item.gm))
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      row.item.gm === null
                                        ? _c("div", [_vm._v("0.00")])
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              4106505958
                            )
                          },
                          [
                            _c("template", { slot: "table-busy" }, [
                              _c(
                                "div",
                                { staticClass: "text-center text-danger my-2" },
                                [
                                  _c("b-spinner", {
                                    staticClass: "align-middle"
                                  }),
                                  _vm._v(" "),
                                  _c("strong", [_vm._v("Загрузка...")])
                                ],
                                1
                              )
                            ])
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isMobile
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-6 col-sm-6" }, [
                _c(
                  "div",
                  { attrs: { role: "status", "aria-live": "polite" } },
                  [
                    _vm._v("Количество строк:\n                "),
                    _c(
                      "b-form-select",
                      {
                        staticStyle: { width: "70px" },
                        attrs: { size: "sm" },
                        on: {
                          change: function($event) {
                            return _vm.getReports()
                          }
                        },
                        model: {
                          value: _vm.pageSize,
                          callback: function($$v) {
                            _vm.pageSize = $$v
                          },
                          expression: "pageSize"
                        }
                      },
                      [
                        _c("option", { domProps: { value: 25 } }, [
                          _vm._v("25")
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: 50 } }, [
                          _vm._v("50")
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: 75 } }, [
                          _vm._v("75")
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: 100 } }, [
                          _vm._v("100")
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: 150 } }, [
                          _vm._v("150")
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: 200 } }, [
                          _vm._v("200")
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { attrs: { role: "status", "aria-live": "polite" } },
                  [
                    _vm._v("Записей на странице: "),
                    _vm.reports && _vm.reports.length
                      ? _c("span", [_vm._v(_vm._s(_vm.reports.length - 2))])
                      : _vm._e(),
                    !_vm.reports ? _c("span", [_vm._v("0")]) : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { attrs: { role: "status", "aria-live": "polite" } },
                  [
                    _vm._v("Всего записей: "),
                    _vm.pager && _vm.pager.total
                      ? _c("span", [_vm._v(_vm._s(_vm.pager.total))])
                      : _vm._e(),
                    !_vm.pager || !_vm.pager.total
                      ? _c("span", [_vm._v("0")])
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6 col-lg-6" }, [
                _c("div", { staticClass: "float-right" }, [
                  _c("nav", { attrs: { "aria-label": "Page navigation" } }, [
                    _c(
                      "ul",
                      { staticClass: "pagination justify-content-center" },
                      [
                        _c("b-pagination", {
                          attrs: {
                            size: "sm",
                            "total-rows": _vm.pager.total,
                            "per-page": _vm.pager.per_page
                          },
                          on: {
                            change: function($event) {
                              return _vm.getReports(
                                $event,
                                { sortBy: _vm.sortBy, sortDesc: _vm.sortDesc },
                                _vm.user,
                                _vm.search
                              )
                            }
                          },
                          model: {
                            value: _vm.pager.current_page,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "current_page", $$v)
                            },
                            expression: "pager.current_page"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Настраиваемый отчет")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c96a40a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c96a40a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/CustomReport.vue
// module id = 1026
// module chunks = 0